<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/y9e00v/tc-custom/9781398407428.jpg?1682168954167" alt="This image is the cover for the book The Falling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Falling
      </h1>
      <p class="bookDescription body article font2">
        <p>Esther was just like any other angel, until the day she was exiled from Heaven for a crime she didn’t commit. But where does an angel go after being exiled from the Holy Land? They go to the underworld to endure an eternity of torture and slavery. Only, Esther discovered that those horrifying stories were not true, and Hell was very much like Heaven and Earth. On her arrival, Esther is welcomed by three demons who take her into their lives: Elvira, Caspian, and the mysterious Prince Zander. But what they all didn’t know was that the moment Esther set foot in Hell, they all fell in grave danger.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kita Cook
      </h2>
      
      <p class="authorDescription body article">I grew up in Inverell, a small rural town in north-east NSW. I started writing The Falling when I was 17. It took me 3 years to finally complete it. I dropped out of school at the start of grade 11, when I was 16. My first job was at a local jewellers’ that unfortunately closed early 2021. But I’m happy to say it was the best 5 years of my life working there, there was never a dull day with those lovely ladies. I am an animal fanatic, having many of mine, but we all have our favourites and mine are my two amazing cats: Pepsi and Minky. I’m a big fan of movies and my all-time favourite character is Batman. I love to write, mainly because it gives me a sense of freedom. I can shut off from the world around me and go anywhere I want. My biggest inspiration is Alexandra Adornetto. Her writing makes me feel like I’m there and her books make me feel so happy and I only want my book to bring the same joy to anyone who reads it. I’m not in it for the fame and fortune. I simply want to brighten up someone’s day, like Alexandra Adornetto did for me. —Kita Cook</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?462d1eec